// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"62":"brand-rigging","155":"brand-danfloss","801":"brand-arg"}[chunkId] || chunkId) + "." + {"62":"13346700","148":"90076712","155":"db687f3f","217":"47f725f9","765":"47ef138b","801":"baba1cbb","888":"176a3f56","934":"dab3070b"}[chunkId] + ".chunk.js";
};